
/* function transformBillers(data) {
  // Helper function to capitalize the first letter of a string
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  // Function to transform each category
  const transformCategory = (category) => {
      // Initialize with the "All" option
      const result = [{
          display: "All",
          payload: "",
      }];

      // Iterate over each item in the category
      category.forEach(item => {
          result.push({
              display: capitalize(item.name),
              payload: item.name,
          });
      });

      return result;
  };

  // Transform all categories
  return {
      airtime: transformCategory(data.airtime),
      data: transformCategory(data.data),
      electricity: transformCategory(data.electricity),
      cableTv: transformCategory(data.cableTv),
  };
} */




const transformArrayIdsAndNames = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.map((item) => ({
    id: item._id,
    name: `${item.firstName} ${item.lastName}`,
    email: item.email,
  }));
};

const extractIds = (data = []) => {
  return data?.map((item) => item._id);
};

// email, jobTitle, createdAt, status

export { transformArrayIdsAndNames, extractIds };
